import tzlookup from "tz-lookup"

/**
 * Resolve IANA timezone at a coordinate and format an instant in that zone.
 *
 * @param {number} lat
 * @param {number} lon
 * @param {string | Date} dateInput - ISO instant (e.g. from feed) or Date
 * @returns {{
 *   timezone: string | null,
 *   formattedLocal: string | null,
 *   timeZoneLabel: string | null,
 *   error?: string
 * }}
 */
export function getTimezoneInfo(lat, lon, dateInput) {
  let timezone
  try {
    timezone = tzlookup(lat, lon)
  } catch {
    return {
      timezone: null,
      formattedLocal: null,
      timeZoneLabel: null,
      error: "No timezone found",
    }
  }

  if (!timezone) {
    return {
      timezone: null,
      formattedLocal: null,
      timeZoneLabel: null,
      error: "No timezone found",
    }
  }

  const instant = dateInput instanceof Date ? dateInput : new Date(dateInput)
  if (Number.isNaN(instant.getTime())) {
    return {
      timezone,
      formattedLocal: null,
      timeZoneLabel: null,
      error: "Invalid date",
    }
  }

  const formattedLocal = new Intl.DateTimeFormat(undefined, {
    timeZone: timezone,
    weekday: "long",
    day: "numeric",
    month: "long",
    year: "numeric",
    hour: "numeric",
    minute: "2-digit",
  }).format(instant)

  const parts = new Intl.DateTimeFormat(undefined, {
    timeZone: timezone,
    timeZoneName: "long",
  }).formatToParts(instant)

  const timeZoneLabel =
    parts.find((p) => p.type === "timeZoneName")?.value ?? null

  return { timezone, formattedLocal, timeZoneLabel }
}
